export const CONFIG = {
  serverUrl: process.env.REACT_APP_SERVER_URL || '',
  apiKey: process.env.REACT_APP_API_KEY || '',
};
